import { useState, useCallback, useEffect } from 'react';

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(null);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);
  const [email, setEmail] = useState(false);
  const [userProfileImageUrl, setProfileImageUrl] = useState(false);
  const [userFirstName, setFirstName] = useState(false);
  const [userLastName, setLastName] = useState(false);
  

  const login = useCallback(
    (id, email, profileImageUrl, firstName, lastName, token, expirationDate) => {
      setToken(token);
      setUserId(id);
      setEmail(email);
      setProfileImageUrl(profileImageUrl);
      setFirstName(firstName);
      setLastName(lastName);
      const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 12);
      setTokenExpirationDate(tokenExpirationDate);
      localStorage.setItem(
        'userData',
        JSON.stringify({
          userId: id,
          token: token,
          email: email,
          profileImageUrl: profileImageUrl,
          firstName: firstName,
          lastName: lastName,
          expiration: tokenExpirationDate.toISOString(),
        })
      );
    },
    []
  );

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    setEmail(null);
    setProfileImageUrl(null);
    setFirstName(null);
    setLastName(null);
    localStorage.removeItem('userData');
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
     
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(
        storedData.userId,
        storedData.email,
        storedData.profileImageUrl,
        storedData.firstName,
        storedData.lastName,
        storedData.token,
        new Date(storedData.expiration)
      );
    }
  }, [login]);

  return { userId, email, userProfileImageUrl, userFirstName, userLastName, token, login, logout };
};
